import React from "react";
import { Club } from "../types";
import { Link } from "react-router-dom";
import ClubItemMedium from "./items/club/medium";

const ClubsList = ({ clubs }: { clubs: Club[] }) => {
	return (
		<div className="table defaultSpacing">
			{clubs.map((club, key) => (
				<Link to={`/club/${club.clubInfo.clubId}`} className="cell" key={key}>
					<ClubItemMedium
						key={key}
						name={club.clubInfo.name}
						meta={club.clubInfo.address1 + ", " + club.clubInfo.city}
						photoUrl={club.clubInfo.photoUrl}
					/>
				</Link>
			))}
		</div>
	);
};

export default ClubsList;
